let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bP5jz")).then(() => parcelRequire('ls2V5'));